module.exports = __webpack_public_path__ + "img/ukraine.f3a2256e.svg";